import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import zihuaLogo from "../../../assets/pdfs/zihua-logo.png";
import header from "../../../assets/pdfs/Mask group.png";
import gradient from "../../../assets/pdfs/background2.png";

// Estilos para el PDF
const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
  },
  sectionHeader: {
    height: "15%",
    justifyContent: "center",
    alignItems: "center",
  },
  sectionFooter: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: "8%",
    justifyContent: "center",
    alignItems: "center",
  },
  headerBackground: {
    position: "absolute",
    width: "100%",
    height: "100%",
  },
  logo: {
    position: "absolute",
    width: "100px",
    height: "100px",
  },
  content: {
    alignItems: "center",
    justifyContent: "center",
    marginTop: 10,
    marginVertical: 20,
    paddingHorizontal: 40,
  },
  title: {
    marginTop: 20,
    marginBottom: 20,
    fontSize: "20px",
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: "bold",
    marginTop: 8,
    marginBottom: 5,
  },
  paragraph: {
    fontSize: 10,
    marginBottom: 10,
    textAlign: "justify",
    lineHeight: 1.5,
  },
  bold: {
    fontWeight: "bold",
  },
  textFooter: {
    color: "white",
    marginVertical: 5,
  },
  signatureContainer: {
    marginTop: 40,
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
    gap: 15,
  },
  signatureBlock: {
    alignItems: "center",
    width: "40%",
  },
  signatureLine: {
    width: "100%",
    height: 1,
    backgroundColor: "black",
    marginBottom: 5,
  },
  signatureName: {
    fontSize: 12,
    textAlign: "center",
  },
});

const UserContract = ({ fullName, land }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.sectionHeader}>
        <Image src={gradient} style={styles.headerBackground} />
        <Image src={header} style={styles.headerBackground} />
        <Image src={zihuaLogo} style={styles.logo} />
      </View>
      <View style={styles.content}>
        <Text style={styles.title}>
          CONTRATO
        </Text>

        <Text style={styles.paragraph}>
          QUE CELEBRAN, POR UNA PARTE, EL/LA C. ZIHUA iNVESTMENTS (EN LO
          SUCESIVO "EL VENDEDOR") Y, POR OTRA PARTE, EL/LA C.{" "}
          {fullName.toUpperCase()} (EN LO SUCESIVO "EL COMPRADOR"), AL TENOR DE
          LAS SIGUIENTES DECLARACIONES Y CLÁUSULAS:
        </Text>

        <Text style={styles.sectionTitle}>DECLARACIONES</Text>

        <Text style={styles.paragraph}>
          <Text style={styles.bold}>I. Declara "EL VENDEDOR":</Text>
          {"\n"}a) Que es legítimo propietario del lote ubicado en{" "}
          {land?.identifying_label}, con las siguientes medidas y colindancias:{" "}
          {land?.description} con un total de {land?.surface}.{"\n"}
          b) Que el lote se encuentra libre de gravámenes, limitaciones de
          dominio, litigios o cualquier otro tipo de carga legal.{"\n"}
          c) Que tiene la capacidad legal para celebrar este contrato.
        </Text>
        <Text style={styles.paragraph}>
          <Text style={styles.bold}>II. Declara "EL COMPRADOR":</Text>
          {"\n"}a) Que está interesado en adquirir el lote descrito
          anteriormente.
          {"\n"}b) Que cuenta con los recursos económicos necesarios para
          cumplir con las obligaciones establecidas en este contrato.{"\n"}c)
          Que tiene plena capacidad legal para celebrar este contrato.
        </Text>
        <Text style={styles.paragraph}>
          <Text style={styles.bold}>III. Declaran ambas partes:</Text>
          {"\n"}a) Que tienen la voluntad de celebrar este contrato de
          compra-venta en los términos establecidos en las siguientes cláusulas.
        </Text>

        <Text style={styles.sectionTitle}>CLÁUSULAS</Text>
        <Text style={styles.paragraph}>
          <Text style={styles.bold}>PRIMERA. OBJETO DEL CONTRATO</Text>
          {"\n"}"EL VENDEDOR" se obliga a vender, y "EL COMPRADOR" se obliga a
          comprar el lote descrito en las declaraciones del presente contrato.
        </Text>
        <Text style={styles.paragraph}>
          <Text style={styles.bold}>SEGUNDA. PRECIO Y FORMA DE PAGO</Text>
          {"\n"}El precio total de la operación es de ${land?.price} por MTS, que
          "EL COMPRADOR" se obliga a pagar de la siguiente manera:{"\n"}a) Un
          anticipo de $10.000, a la
          firma del presente contrato.
          {"\n"}
          b) El saldo restante de $40.000, será liquidado mediante transferencia bancaria.
        </Text>

        <View style={styles.signatureContainer}>
          <View style={styles.signatureBlock}>
            <View style={styles.signatureLine} />
            <Text style={styles.signatureName}>Firma del Vendedor</Text>
          </View>
          <View style={styles.signatureBlock}>
            <View style={styles.signatureLine} />
            <Text style={styles.signatureName}>Firma del Comprador</Text>
          </View>
        </View>
      </View>
      <View style={styles.sectionFooter}>
        <Image src={gradient} style={styles.headerBackground} />
        <Text style={styles.textFooter}>zihuainvest.com</Text>
        <Text style={styles.textFooter}>info@zihuainvest.com</Text>
      </View>
    </Page>
  </Document>
);

export default UserContract;
